import { render } from "./ModalServiceUnavailable.vue?vue&type=template&id=2b9d181e"
import script from "./ModalServiceUnavailable.vue?vue&type=script&lang=js"
export * from "./ModalServiceUnavailable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__